export default "__VITE_ASSET__p_61y4HT__"